import { throttle } from 'lodash';
import { useRef, useEffect } from 'react';

const THROTTLE_DELAY = 150;

interface InfiniteLoadObserverProps {
  onIntersect?: () => void;
  thresholdAbove?: number;
}

const InfiniteLoadObserver = ({
  onIntersect,
  thresholdAbove = 0,
}: InfiniteLoadObserverProps) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (ref.current && onIntersect) {
      const onScroll = throttle(() => {
        if (ref.current) {
          const { top, height, width } = ref.current.getBoundingClientRect();

          // Ensure that element exists on the page by taking a space.
          if (height && width && top - thresholdAbove <= window.innerHeight) {
            onIntersect();
          }
        }
      }, THROTTLE_DELAY);

      window.addEventListener('scroll', onScroll);
      onScroll();

      return () => {
        window.removeEventListener('scroll', onScroll);
      };
    }
  }, [onIntersect, thresholdAbove]);

  return onIntersect ? (
    <div
      ref={ref}
      data-testid="infinite-load-observer"
      style={{ height: '1px' }}
    />
  ) : null;
};

export default InfiniteLoadObserver;
